import React, { forwardRef } from 'react'
import classNames from 'classnames'

import { SIZE } from '@app/constants'

import { LntButton } from '../LntButton'

import styles from './styles.module.scss'

import type { LntIconButtonProps } from './types'

const Component: React.ForwardRefRenderFunction<HTMLElement, LntIconButtonProps> = (props, ref) => {
  const { className: outerClassName, size = SIZE.middle, ...restProps } = props

  const sizeClassMap = {
    [styles.iconButton__small]: size === SIZE.small,
    [styles.iconButton__middle]: size === SIZE.middle,
    [styles.iconButton__large]: size === SIZE.large
  }

  const className = classNames(styles.iconButton, sizeClassMap, outerClassName)

  return (
    <LntButton
      { ...restProps }
      className={ className }
      size={ size }
      ref={ ref }
    />
  )
}

export const LntIconButton = forwardRef<HTMLElement, LntIconButtonProps>(Component)
